import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";
import { RedeemCodeModalCreateAble } from "@components/modal/RedeemCode/RedeemCodeModal";
import { redirectToLoginPage } from "@features/login/redirectToLoginPage";
import { Track } from "@/src/lib/tracking";

/** 会员页兑换链接携带兑换码的查询参数：/member?tab=currentPlan&inviteSpreadCode={code} */
export const INVITE_SPREAD_CODE_PARAM = "inviteSpreadCode";

/** 正在处理的链接兑换码：防止重渲染或组件重挂载时重复弹窗 */
let handlingInviteSpreadCode: string | null = null;

/** 只去掉兑换码参数，保留 tab 等其他参数 */
export function removeInviteSpreadCodeFromUrl(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(INVITE_SPREAD_CODE_PARAM);
  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}${url.hash}`,
  );
}

/**
 * 处理会员页链接带来的兑换码。
 *
 * - 未登录：直接去登录，链接原样作为 returnUrl，登录回来再弹；兑换本身要求登录，弹了也兑换不了。
 * - 已登录：等全局弹窗 Root 就绪再弹（Root 经 lazyHydrate 延迟挂载，首屏直接 call 会抛 `No <Root> found`）。
 * - 弹窗处理完（关闭或兑换成功）才清掉地址栏里的码；打不开时保留，刷新可重试。
 *
 * @param code       链接里的兑换码（已 trim）
 * @param isLoggedIn 登录状态，调用方须在登录状态确定后再调用
 */
export async function handleInviteSpreadCodeFromLink(
  code: string,
  isLoggedIn: boolean,
): Promise<void> {
  if (!code || handlingInviteSpreadCode === code) {
    return;
  }
  if (!isLoggedIn) {
    // Partner 链接漏斗：未登录先去登录，登录回来再弹（弹窗曝光带 source=link）
    Track.event("member_redeem_login", { source: "link" });
    redirectToLoginPage();
    return;
  }
  handlingInviteSpreadCode = code;
  try {
    await callEdgenModalWhenRootReadyAsync(() =>
      RedeemCodeModalCreateAble({ code, source: "link" }),
    );
    removeInviteSpreadCodeFromUrl();
  } catch (error) {
    Track.error(error, {
      tag: "GiftCodeSection",
      msg: "Failed to open redeem code modal from link",
    });
  } finally {
    handlingInviteSpreadCode = null;
  }
}
